/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Speciallist_Replayabilitystrong2Inputs */

const id_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replayabilitas`)
};

const ms_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebolehan Main Semula`)
};

const da_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genafspilningsværdi`)
};

const de_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederspielbarkeit`)
};

const en_us2_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replayability`)
};

const es_es2_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejugabilidad`)
};

const es_mx2_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejugabilidad`)
};

const fil_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replayability`)
};

const fr_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejouabilité`)
};

const it_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rigiocabilità`)
};

const hu_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Újrajátszhatóság`)
};

const nl_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HerSpeelbaarheid`)
};

const no_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GjenSpillbarhet`)
};

const pl_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regrywalność`)
};

const pt_br2_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogabilidade`)
};

const pt_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejogabilidade`)
};

const ro_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejucabilitate`)
};

const fi_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uudelleenpelattavuus`)
};

const sv_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omissionsbarhet`)
};

const vi_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khả năng chơi lại`)
};

const tr_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar Oynanabilirlik`)
};

const cs_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znovuhratelnost`)
};

const bg_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторяемост`)
};

const ru_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реиграбельность`)
};

const uk_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реплеябельність`)
};

const ar_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قابلية إعادة اللعب`)
};

const hi_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुनः खेलने की क्षमता`)
};

const th_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสามารถในการเล่นซ้ำ`)
};

const ja_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リプレイ性`)
};

const zh_cn2_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重玩价值`)
};

const zh_hant1_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重玩價值`)
};

const ko_misc_posts_speciallist_replayabilitystrong2 = /** @type {(inputs: Misc_Posts_Speciallist_Replayabilitystrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재플레이성`)
};

/**
* | output |
* | --- |
* | "Replayability" |
*
* @param {Misc_Posts_Speciallist_Replayabilitystrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_speciallist_replayabilitystrong2 = /** @type {((inputs?: Misc_Posts_Speciallist_Replayabilitystrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Speciallist_Replayabilitystrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "ms") return ms_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "da") return da_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "de") return de_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "fil") return fil_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "fr") return fr_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "it") return it_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "hu") return hu_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "nl") return nl_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "no") return no_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "pl") return pl_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "pt") return pt_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "ro") return ro_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "fi") return fi_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "sv") return sv_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "vi") return vi_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "tr") return tr_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "cs") return cs_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "bg") return bg_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "ru") return ru_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "uk") return uk_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "ar") return ar_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "hi") return hi_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "th") return th_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "ja") return ja_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_speciallist_replayabilitystrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_speciallist_replayabilitystrong2(inputs)
	return ko_misc_posts_speciallist_replayabilitystrong2(inputs)
});
export { misc_posts_speciallist_replayabilitystrong2 as "misc.posts.specialList.replayabilityStrong" }